import {Slide, ToastOptions, toast} from 'react-toastify';

export enum TOAST_TYPES {
    success = 'success',
    info = 'info',
    warning = 'warning',
    error = 'error',
    default = 'default'
}

class ToastifyService {
    toastOptions: ToastOptions = {
        transition: Slide,
        closeOnClick: true,
        closeButton: false,
        theme: 'dark'
    };

    render = {
        success: toast.success,
        info: toast.info,
        warning: toast.warn,
        error: toast.error,
        default: toast
    };

    toast(message: string = '', type: TOAST_TYPES = TOAST_TYPES.default, customOptions: ToastOptions = {}) {
        this.render[type](message, {...this.toastOptions, ...customOptions});
    }
}

export default new ToastifyService();
